import { connect } from 'react-redux';
import BusinessCaseBuilderView from './business-case-builder.presenter';

// Map & Connect
export const mapStateToProps = state => ({
  productRecommendation: state.homePageReducer.productRecommendation.filter(productData => productData.recommendationSelected),
  authorableContent: state.authorableContentReducer.authorableContent.marketComparison.businessCaseBuilder,
  cidn: state.dataBootStrapReducer.authentication.cidn,
});

const BusinessCaseBuilder = connect(
  mapStateToProps,
)(BusinessCaseBuilderView);

export default BusinessCaseBuilder;
